<template>
    <div class="cc-wrapper">
        <CardContainer :cards="cards_left" gradient="left"/>
        <CardContainer v-if="screen_width >= 900" :cards="cards_center" :gradient="screen_width >= 1300 ? 'center' : 'right'"/>
        <CardContainer v-if="screen_width >= 1300" :cards="cards_right" gradient="right"/>
    </div>
    
</template>

<script setup lang="js">
import { ref, onMounted, onUnmounted } from 'vue';
import CardContainer from '@/components/basic_components/CardContainer.vue';

onMounted(() => {
    window.addEventListener('resize', (e) => {e.preventDefault(); screen_width.value = window.innerWidth; distributeCards();});
    distributeCards();
})

onUnmounted(() => {
    window.removeEventListener('resize', (e) => {e.preventDefault(); screen_width.value = window.innerWidth; distributeCards();});
})

/**
 * Divides the available cards into cards_left, _center and _right.
 * Cards should be passed as a prop later.
 */
const distributeCards = () => {
    cards_left.value.splice(0, cards_left.value.length);
    cards_center.value.splice(0, cards_center.value.length);
    cards_right.value.splice(0, cards_right.value.length);
    let list_lengths = {left: 0, center: 0, right: 0};
    for (const card of cards) {
        let card_measure = (card.content?.length / 12 + 100);
        if (screen_width.value < 900) {
            cards_left.value.push(card);
            list_lengths.left += card_measure;
            continue;
        } 
        else if (screen_width.value < 1300 && screen_width.value >= 900) {
            if (list_lengths.left <= list_lengths.center) {
                cards_left.value.push(card);
                list_lengths.left += card_measure;
                continue;
            } else {
                cards_center.value.push(card);
                list_lengths.center += card_measure;
                continue;
            }
        }
        else {
            if (list_lengths.left <= list_lengths.center && list_lengths.left <= list_lengths.right) {
                cards_left.value.push(card);
                list_lengths.left += card_measure;
                continue;
            } else if (list_lengths.center <= list_lengths.right) {
                cards_center.value.push(card);
                list_lengths.center += card_measure;
                continue;
            } else {
                cards_right.value.push(card);
                list_lengths.right += card_measure;
                continue;
            }

        }
    }
}

const screen_width = ref(window.innerWidth);
const cards_left = ref([]);
const cards_center = ref([]);
const cards_right = ref([]);

const cards = [
    {title: 'Paragraphs', content: '<p>Paragraph</p><p>Paragraph</p>', id: 'cardp'},
    {title: 'OL', content: '<ol><li>List</li><li>Yeah we listing</li><li>List test and shit</li></ol>', id: 'cardol', icon: 'mdi-list-box'},
    {title: 'Large Lorem', content: ' Some way too large text. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.', id: 'cardll', icon: 'mdi-text-box'},
    {title: 'Smol', content: 'Some random small text.', id: 'cards', icon: 'mdi-text-long'},
    {title: 'Vuetify?', content: '<span>There would be a button</span>', id: 'cardv', icon: 'mdi-button-cursor'},
    {title: 'UL', content: '<ul><li>Yet</li><li>another</li><li>list, but unordered</li></ul>', id: 'cardu', icon: 'mdi-format-list-bulleted'},
    {title: 'Nothing', content: '', id: 'cardn', icon: 'mdi-border-none-variant'},
    {title: 'Own component?', component: 'DIRECTIVE:PATHOBAR', value: 0.58, min: 0, max: 0, id: 'cardc', icon: 'mdi-chart-bar', content: '<p>Some text under a pathobar</p>'},
    {title: 'Lorem Ipsum', content: ' Longer text. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.', id: 'cardli', icon: 'mdi-text'},
]
</script>

<style scoped>

.cc-wrapper {
    height: 90%;
    position: absolute;
    top: 20px;
    display: grid;
    justify-content: center;
    gap: 8px;
    margin: auto;
    grid-template-columns: 98%;
    overflow-y: auto;
}

@media screen and (min-width: 900px) {
    
    .cc-wrapper {
         grid-template-columns: repeat(2, 49%);
    }

}

@media screen and (min-width: 1300px) {
    
    .cc-wrapper {
         grid-template-columns: repeat(3, 32%);
    }

}

</style>
